module.exports = __webpack_public_path__ + "static/media/digital_farm.f0494d12.png";